import React, { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import Joi from 'joi';

class ModalSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderNumericField = this.renderNumericField.bind(this);
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.props.show) {
      this.props.initialize({ lowerBound: nextProps.lowerBound, upperBound: nextProps.upperBound });
    }
  }

  close() {
    this.props.onClose();
  }
  handleSubmit(data) {
    this.props.onBoundChange(Math.min(data.lowerBound, data.upperBound), Math.max(data.lowerBound, data.upperBound));
    this.close();
  }
  renderNumericField({
    input, label, prefix, placeholder, className, thousandSeparator, meta: { touched, error },
  }) {
    const { submitting, fieldPrefix, fieldSuffix } = this.props;

    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState} className={className}>
        <ControlLabel>{label}</ControlLabel>
        <div className="input-group">
          {fieldPrefix && <span className="input-group-addon">{fieldPrefix}</span>}
          <NumberFormat
            value={input.value}
            thousandSeparator={thousandSeparator}
            className="form-control"
            prefix={prefix}
            disabled={submitting}
            placeholder={placeholder}
            onValueChange={(values) => {
              this.props.change(input.name, parseFloat(values.value));
              this.props.touch(input.name);
            }}
          />
          {fieldSuffix && <span className="input-group-addon">{fieldSuffix}</span>}
        </div>
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error.join('. ')}</HelpBlock>}
      </FormGroup>
    );
  }
  render() {
    const {
      handleSubmit, submitting, show, valid, title, lowerLabel, upperLabel,
    } = this.props;
    return (
      <Modal show={show} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Body>
            <div className="row">
              <Field
                name="lowerBound"
                type="text"
                component={this.renderNumericField}
                label={lowerLabel}
                thousandSeparator
                className="col-sm-6"
              />
              <Field
                name="upperBound"
                type="text"
                component={this.renderNumericField}
                label={upperLabel}
                thousandSeparator
                className="col-sm-6"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="link" disabled={submitting} onClick={this.close}>Cancel</Button>
            <Button bsStyle="primary" disabled={submitting || !valid} type="submit">Apply</Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}


ModalSlider.propTypes = {
  initialize: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  touch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  show: PropTypes.bool,
  lowerBound: PropTypes.number.isRequired,
  title: PropTypes.string,
  lowerLabel: PropTypes.string,
  upperLabel: PropTypes.string,
  fieldPrefix: PropTypes.string,
  fieldSuffix: PropTypes.string,
  upperBound: PropTypes.number.isRequired,
  onBoundChange: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  valid: PropTypes.bool.isRequired,
};
ModalSlider.defaultProps = {
  show: false,
  title: 'Change Boundaries',
  lowerLabel: 'Lower Bound',
  upperLabel: 'Upper Bound',
  fieldPrefix: null,
  fieldSuffix: null,
  onClose: () => {},
};
// Legacy constraints for reference:
// const constraints = {
//   lowerBound: {
//     presence: true,
//     numericality: { greaterThanOrEqualTo: 0, strict: true },
//   },
//   upperBound: {
//     presence: true,
//     numericality: { greaterThanOrEqualTo: 0, strict: true },
//   },
// };

const schema = Joi.object({
  lowerBound: Joi.number().min(0).required().messages({
    'number.base': 'Lower bound must be a number',
    'number.min': 'Lower bound must be at least 0',
    'any.required': 'Lower bound is required',
  }),
  upperBound: Joi.number().min(0).required().messages({
    'number.base': 'Upper bound must be a number',
    'number.min': 'Upper bound must be at least 0',
    'any.required': 'Upper bound is required',
  }),
}).unknown(true);

const validate = (data) => {
  const { error } = schema.validate(data, { abortEarly: false });
  if (!error) return {};
  // Map Joi errors to redux-form format
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};
function mapStateToProps() {
  return {};
}
const ModalSliderForm = reduxForm({
  form: 'modalSliderForm',
  validate,
})(ModalSlider);

export default connect(mapStateToProps)(ModalSliderForm);
